import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as myGlobals from "../../../../../app.component";

@Component({
  selector: 'app-view-grievance-attachment',
  templateUrl: './view-grievance-attachment.component.html',
  styleUrls: ['./view-grievance-attachment.component.scss']
})
export class ViewGrievanceAttachmentComponent implements OnInit {

  public baseUrl = myGlobals.baseFileUrl;
  imgData:any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { 
      this.imgData=data["data"];
      this.baseUrl=this.baseUrl+this.imgData;
  }
   
  ngOnInit(): void {
  }
}
